// extracted by css-extract-rspack-plugin
export default {"default":"DescriptionItem-module__default__LggVfB_","compact":"DescriptionItem-module__compact__bdfJw7v"};